module.exports = __webpack_public_path__ + "static/img/section1-contact-new.a7d4fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section1-contact-new.png
// module id = Mg/f
// module chunks = 0